__turbopack_context__.v({
  "infoButton": "FlywaysMapMobileChrome-module__EHa9Fa__infoButton",
  "legendItem": "FlywaysMapMobileChrome-module__EHa9Fa__legendItem",
  "legendLabel": "FlywaysMapMobileChrome-module__EHa9Fa__legendLabel",
  "legendList": "FlywaysMapMobileChrome-module__EHa9Fa__legendList",
  "legendSwatch": "FlywaysMapMobileChrome-module__EHa9Fa__legendSwatch",
  "nav": "FlywaysMapMobileChrome-module__EHa9Fa__nav",
  "panHint": "FlywaysMapMobileChrome-module__EHa9Fa__panHint",
  "panHintImg": "FlywaysMapMobileChrome-module__EHa9Fa__panHintImg",
  "popover": "FlywaysMapMobileChrome-module__EHa9Fa__popover",
  "popoverBadgeLabel": "FlywaysMapMobileChrome-module__EHa9Fa__popoverBadgeLabel",
  "popoverCount": "FlywaysMapMobileChrome-module__EHa9Fa__popoverCount",
  "popoverHeader": "FlywaysMapMobileChrome-module__EHa9Fa__popoverHeader",
});
